import React from 'react';
import {
  Box,
  SimpleGrid,
  Text,
  Button,
  Heading,
  Flex,
  useColorModeValue,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { FaFileExcel, FaUserClock, FaStopwatch, FaChevronRight } from 'react-icons/fa';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import { primaryButtonProps } from '../../../theme/adminUi';

const REPORTS = [
  {
    title: 'Reporte CEM',
    description:
      'Planilla CEM de vehículos únicos atendidos en un período. Descargá el Excel con el formato requerido.',
    path: '/admin/reports/cem',
    icon: FaFileExcel,
    accent: '#2F855A',
    accentSoft: '#E6F4EC',
  },
  {
    title: 'Productividad',
    description:
      'Tiempo productivo de cada mecánico/ayudante y cuánto trabajaron juntos en el período.',
    path: '/admin/reports/productivity',
    icon: FaStopwatch,
    accent: '#003064',
    accentSoft: '#E8EEF5',
  },
  {
    title: 'Reporte SBS',
    description:
      'Reporte mensual Volkswagen por mes: pasos, horas, mantenimientos y ventas.',
    path: '/admin/reports/sbs',
    icon: FaFileExcel,
    accent: '#003064',
    accentSoft: '#E8EEF5',
  },
  {
    title: 'Configuración SBS',
    description:
      'Personal, capacidad del taller, dólar, días laborales y parámetros mensuales del reporte SBS.',
    path: '/admin/reports/sbs-config',
    icon: FaFileExcel,
    accent: '#4A5568',
    accentSoft: '#EDF2F7',
  },
  {
    title: 'Clientes sin visita',
    description:
      'Clientes y vehículos sin servicio en un período personalizado.',
    path: '/admin/reports/inactive-customers',
    icon: FaUserClock,
    accent: '#C05621',
    accentSoft: '#F9EDE6',
  },
];

export default function ReportsHome() {
  const navigate = useNavigate();
  const border = useColorModeValue('gray.200', 'whiteAlpha.300');
  const muted = useColorModeValue('gray.600', 'gray.400');

  return (
    <AdminPageShell title="Reportes">
      <Text fontSize="sm" color={muted} mb={5}>
        Elegí un reporte. En cada uno vas a poder definir un período personalizado
        y ver una vista previa antes de descargar.
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing={4}>
        {REPORTS.map((report) => {
          const Icon = report.icon;
          return (
            <Box
              key={report.path}
              as="button"
              textAlign="left"
              borderWidth="1px"
              borderColor={border}
              borderRadius="lg"
              p={5}
              bg="white"
              position="relative"
              overflow="hidden"
              transition="all 0.15s ease"
              _hover={{
                borderColor: report.accent,
                bg: report.accentSoft,
                transform: 'translateY(-1px)',
                shadow: 'sm',
              }}
              onClick={() => navigate(report.path)}
            >
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                h="4px"
                bg={report.accent}
              />
              <Flex align="flex-start" justify="space-between" gap={3} mb={3} mt={1}>
                <Flex
                  align="center"
                  justify="center"
                  w="42px"
                  h="42px"
                  borderRadius="md"
                  bg={report.accent}
                  color="white"
                >
                  <Box as={Icon} boxSize={5} />
                </Flex>
                <Box as={FaChevronRight} color={report.accent} mt={2} boxSize={3} />
              </Flex>
              <Heading size="sm" mb={2} color="gray.800">
                {report.title}
              </Heading>
              <Text fontSize="sm" color={muted} lineHeight="1.5" mb={4}>
                {report.description}
              </Text>
              <Button {...primaryButtonProps} pointerEvents="none">
                Abrir reporte
              </Button>
            </Box>
          );
        })}
      </SimpleGrid>
    </AdminPageShell>
  );
}
